import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import TagsInput from 'react-tagsinput';
import 'react-tagsinput/react-tagsinput.css';

const MultiInputGroup = ({ label, wrapperClass, onOpenPopupInfo, onChange, ...props }) => {
  const { t } = useTranslation('common');
  return (
    <div className={`form-group ${wrapperClass}`}>
      {label && (
        <span className="label-item">
          {t(label)}
          {label && props.required && <i className="fa fa-star is-required" />}
          &nbsp;
        </span>
      )}
      <div className="wr-input" id={`${props.name}`}>
        <TagsInput addKeys={[13, 32]} onChange={onChange} className="form-control input-group email-input" {...props} />
      </div>
    </div>
  );
};

MultiInputGroup.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  wrapperClass: PropTypes.string,
  onChange: PropTypes.func,
  onOpenPopupInfo: PropTypes.func,
  required: PropTypes.bool,
};

MultiInputGroup.defaultProps = {
  label: '',
  onChange: () => {},
  onOpenPopupInfo: () => {},
  type: 'text',
  wrapperClass: 'col-md-3',
  required: false,
};

export default MultiInputGroup;
